<template>
    <section class="impotent-message-wrapper" :class="{
        'tourism-view-active': $route.path.includes('/agent/tourismBooking'), 'tourismBook-view-active': $route.path.includes('/agent/tourismList/tourismBook'),
        'tourism-list-active': $route.path.includes('/agent/tourismList'), 'ledger-view-active': $route.path.includes('/agent/report/ledger'), 'flight-details-active': $route.path.includes('/agent/flight/details'), 'pre_booking-active': $route.path.includes('/agent/flight/pre_booking_page')
        , 'train-Process-active': $route.path.includes('/agent/train/trainProcessBooking')
    }">
        <div class="container-fluid custom-container " v-if="showScroll2">
            <div class="impotent-message-sec">
                <div class="impotent-message-con">
                    <div class="impotent-con">
                        <div class="impotent-img">
                            <img src="../../public/Agent/images/megaphone-icon.svg" alt="">
                        </div>
                        <span class="thm-heading-paragraph">Important Message</span>
                    </div>
                    <!-- <marquee class="thm-heading-paragraph marquee-text" direction="left" loop="true"  onmouseover="this.stop();"
                     onmouseout="this.start();">Your irctc renewal date is expires within 23 days ! please renew it before time to use irctc related service without any interruption.</marquee> -->
                    <div class="marquee2" id="showScroll2" >
                        <div class="marquee__inner2 thm-heading-paragraph marquee-text" aria-hidden="true">
                            Your irctc renewal date is expires within 23 days ! please renew it before time to use irctc
                            related service without any interruption.
                        </div>
                    </div>

                </div>
            </div>
        </div>

        <div class="mega-menu-wrapper" @mouseenter="showTooltip = true" @mouseleave="showTooltip = false">
            <div class="container-fluid custom-container ">
                <div class="mega-menu-sec">
                    <div class="mega-menu-tab-sec">
                        <ul>
                            <li v-if="UserPrivileges.includes('PNF')">
                                <button type="button" class="active menuhover-active"
                                    @mouseenter="scrollToServiceSection('Flight-sec')"
                                    @click="handleNav('/agent/flight')">
                                    <div class="mega-menu-tab-img">
                                        <img src="../../public/Agent/images/flight-tab-icon.svg" alt="">
                                    </div>
                                    <div class="mega-tab-sub-con">
                                        <h6 class="thm-heading-six">Flight <span><img
                                                    src="../../public/Agent/images/arrow-down.svg" alt=""></span></h6>
                                    </div>
                                </button>
                            </li>
                            <li v-if="UserPrivileges.includes('PNT')">
                                <button type="button" class="menuhover-active" @click="handleNav('/agent/train')"
                                    @mouseenter="scrollToServiceSection('Train-sec')">
                                    <div class="mega-menu-tab-img">
                                        <img src="../../public/Agent/images/train-tab-icon.svg" alt="">
                                    </div>
                                    <div class="mega-tab-sub-con">
                                        <h6 class="thm-heading-six">Train <span><img
                                                    src="../../public/Agent/images/arrow-down.svg" alt=""></span></h6>
                                    </div>
                                </button>
                            </li>
                            <li v-if="UserPrivileges.includes('217')">
                                <button type="button" class="menuhover-active "
                                    @mouseenter="scrollToServiceSection('money-transfer')">
                                    <div class="mega-menu-tab-img">
                                        <img src="../../public/Agent/images/money-tab-icon.svg" alt="">
                                    </div>
                                    <div class="mega-tab-sub-con">
                                        <h6 class="thm-heading-six"> Money Transfer <span><img
                                                    src="../../public/Agent/images/arrow-down.svg" alt=""></span></h6>
                                    </div>
                                </button>
                            </li>
                            <li v-if="UserPrivileges.includes('219')">
                            <!-- <li> -->
                                <button type="button" class="menuhover-active"
                                    @click="handleNav('/agent/hotel')"
                                    @mouseenter="scrollToServiceSection('hotel-sec')">
                                    <div class="mega-menu-tab-img">
                                        <img src="../../public/Agent/images/hotel-tab-icon.svg" alt="">
                                    </div>
                                    <div class="mega-tab-sub-con">
                                        <h6 class="thm-heading-six">Hotel <span><img
                                                    src="../../public/Agent/images/arrow-down.svg" alt=""></span></h6>
                                    </div>
                                </button>
                            </li>
                            <li v-if="UserPrivileges.includes('218')">
                                <button type="button" class="menuhover-active"
                                    @mouseenter="scrollToServiceSection('bus-sec')">
                                    <div class="mega-menu-tab-img">
                                        <img src="../../public/Agent/images/bus-tab-icon.svg" alt="">
                                    </div>
                                    <div class="mega-tab-sub-con">
                                        <h6 class="thm-heading-six">Bus <span><img
                                                    src="../../public/Agent/images/arrow-down.svg" alt=""></span></h6>
                                    </div>
                                </button>
                            </li>
                            <li v-if="UserPrivileges.includes('220')">
                                <button type="button" class="menuhover-active"
                                    @mouseenter="scrollToServiceSection('recharge-sec')">
                                    <div class="mega-menu-tab-img">
                                        <img src="../../public/Agent/images/recharge-tab-icon.svg" alt="">
                                    </div>
                                    <div class="mega-tab-sub-con">
                                        <h6 class="thm-heading-six">Recharge <span><img
                                                    src="../../public/Agent/images/arrow-down.svg" alt=""></span></h6>
                                    </div>
                                </button>
                            </li>
                            <li v-if="UserPrivileges.includes('221')">
                                <button type="button" class="menuhover-active"
                                    @mouseenter="scrollToServiceSection('holiday-sec')">
                                    <div class="mega-menu-tab-img">
                                        <img src="../../public/Agent/images/mega-menu-tab-holiday.svg" alt="">
                                    </div>
                                    <div class="mega-tab-sub-con">
                                        <h6 class="thm-heading-six">Holiday <span><img
                                                    src="../../public/Agent/images/arrow-down.svg" alt=""></span></h6>
                                    </div>
                                </button>
                            </li>
                            <li v-if="UserPrivileges.includes('226')">
                                <button type="button" class="menuhover-active"
                                    @mouseenter="scrollToServiceSection('tourism-sec')"
                                    @click="handleNav('/agent/tourismBooking')">
                                    <div class="mega-menu-tab-img">
                                        <img src="../../public/Agent/images/tourism-tab-icon.svg" alt="">
                                    </div>
                                    <div class="mega-tab-sub-con">
                                        <h6 class="thm-heading-six">Irctc Tourism <span><img
                                                    src="../../public/Agent/images/arrow-down.svg" alt=""></span></h6>
                                    </div>
                                </button>
                            </li>
                            <li>
                                <button type="button" class="menuhover-active"
                                    @mouseenter="scrollToServiceSection('more-tab-sec')"
                                    @click="closeMegaMenu()">
                                    <div class="mega-menu-tab-img">
                                        <img src="../../public/Agent/images/more-tab-icon.svg" alt="">
                                    </div>
                                    <div class="mega-tab-sub-con">
                                        <h6 class="thm-heading-six">More <span>
                                                <img src="../../public/Agent/images/arrow-down.svg" alt=""></span></h6>
                                    </div>
                                </button>
                            </li>
                        </ul>
                    </div>
                    <div class="menu-tab-con" v-if="showTooltip">

                        <div class="menu-tab-item menuhover-active" id="Flight-sec">
                            <div class="menu-tab-item-row">
                                <div class="menu-tab-list menu-tab-width">
                                    <div class="menu-tab-list-header">
                                        <button type="button" class="thm-heading-six" v-on:click="menusubtab">Schedule
                                        </button>
                                    </div>
                                    <div class="mega-menu-tab-sub-con">
                                        <ul>
                                            <li> <router-link to="#" class="thm-heading-paragraph"> Trip
                                                    Calendar</router-link></li>
                                            <li> <router-link to="#" class="thm-heading-paragraph"> Flight Offline
                                                    Booking</router-link></li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="menu-tab-list menu-tab-width">
                                    <div class="menu-tab-list-header">
                                        <button type="button" class="thm-heading-six" v-on:click="menusubtab">Search
                                        </button>
                                    </div>
                                    <div class="mega-menu-tab-sub-con">
                                        <ul>
                                            <li> <router-link to="#" class="thm-heading-paragraph"
                                                    @click.prevent="handleNav('/agent/flight')"> Book Now</router-link>
                                            </li>
                                            <li><router-link to="#" class="thm-heading-paragraph"> Hot
                                                    Deals</router-link>
                                            </li>
                                            <li> <router-link to="#" class="thm-heading-paragraph"> Offline
                                                    Billing</router-link></li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="menu-tab-list menu-tab-width">
                                    <div class="menu-tab-list-header">
                                        <button type="button" class="thm-heading-six" v-on:click="menusubtab">Report
                                        </button>
                                    </div>
                                    <div class="mega-menu-tab-sub-con">
                                        <ul>
                                            <li> <router-link to="#" class="thm-heading-paragraph"
                                                    @click="handleNav('/agent/flight/bookingreport')"> Booking
                                                    report</router-link> </li>
                                            <li> <router-link to="#" class="thm-heading-paragraph"> View
                                                    booking</router-link></li>
                                            <li> <router-link to="#" class="thm-heading-paragraph"> Cancel
                                                    booking</router-link></li>
                                            <li> <router-link to="#" class="thm-heading-paragraph"> My
                                                    invoice</router-link>
                                            </li>
                                            <li> <router-link to="#" class="thm-heading-paragraph"> Customer
                                                    invoice</router-link></li>
                                            <li> <router-link to="#" class="thm-heading-paragraph">
                                                    Reschedule</router-link>
                                            </li>
                                            <li> <router-link to="#" class="thm-heading-paragraph">
                                                    Commission</router-link>
                                            </li>
                                            <li> <router-link to="#" class="thm-heading-paragraph"
                                                    @click.prevent="handleNav('/agent/flight/refund_report')"> Refund
                                                    Reports</router-link></li>
                                            <li> <router-link to="#" class="thm-heading-paragraph"
                                                    @click.prevent="handleNav('/agent/report/ledger')"> Ledger</router-link></li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="menu-tab-list menu-tab-width">
                                    <div class="menu-tab-list-header">
                                        <button type="button" class="thm-heading-six" v-on:click="menusubtab">Accounts
                                        </button>
                                    </div>
                                    <div class="mega-menu-tab-sub-con">
                                        <ul>
                                            <li><router-link to="#" class="thm-heading-paragraph">Markup</router-link>
                                            </li>

                                        </ul>
                                    </div>
                                </div>
                                <div class="menu-tab-list menu-tab-width">
                                    <div class="menu-tab-list-header">
                                        <button type="button" class="thm-heading-six" v-on:click="menusubtab">Travelers
                                        </button>
                                    </div>
                                    <div class="mega-menu-tab-sub-con">
                                        <ul>
                                            <li><router-link to="#" class="thm-heading-paragraph">Manage traveler</router-link></li>

                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="menu-tab-item menuhover-active" id="Train-sec">
                            <div class="menu-tab-item-row">
                                <div class="menu-tab-list menu-tab-width">
                                    <div class="menu-tab-list-header">
                                        <button type="button" class="thm-heading-six" v-on:click="menusubtab">Schedule
                                        </button>
                                    </div>
                                    <div class="mega-menu-tab-sub-con">
                                        <ul>
                                            <!-- <li> <router-link to="#" class="thm-heading-paragraph">Trip
                                                    Calendar</router-link></li> -->
                                            <li> <router-link to="#" class="thm-heading-paragraph"
                                                    @click="$router.replace('/agent/train/get-trip-calendar')">Trip Calendar</router-link></li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="menu-tab-list menu-tab-width">
                                    <div class="menu-tab-list-header">
                                        <button type="button" class="thm-heading-six" v-on:click="menusubtab">Search
                                        </button>
                                    </div>
                                    <div class="mega-menu-tab-sub-con">
                                        <ul>
                                            <li> <router-link to="#" class="thm-heading-paragraph"
                                                    @click.prevent="handleNav('/agent/train')"> Book Now</router-link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="menu-tab-list menu-tab-width">
                                    <div class="menu-tab-list-header">
                                        <button type="button" class="thm-heading-six" v-on:click="menusubtab">Report
                                        </button>
                                    </div>
                                    <div class="mega-menu-tab-sub-con">
                                        <ul>
                                            <li> <router-link to="#" class="thm-heading-paragraph"
                                                    @click.prevent="handleNav('/agent/train/report')"> Booking report
                                                </router-link> </li>
                                            <li> <router-link to="/agent/train/report?tab=pills-viewticket-tab" class="thm-heading-paragraph">View Ticket</router-link></li>
                                            <li> <router-link to="/agent/train/report?tab=pills-cancelticket-tab" class="thm-heading-paragraph"> Cancel ticket</router-link></li>
                                            <li> <router-link to="#" class="thm-heading-paragraph"> PNR details</router-link></li>
                                            <li> <router-link to="#" class="thm-heading-paragraph"
                                                    @click.prevent="handleNav('/agent/train/report?tab=pills-trdrequest-tab')"> TDR Form</router-link></li>
                                            <li> <router-link to="#" class="thm-heading-paragraph"
                                                    @click.prevent="handleNav('/agent/train/report?tab=pills-requesthistory-tab')"> TDR request history</router-link></li>
                                            <!-- <li> <router-link to="#" class="thm-heading-paragraph"> Change boarding time</router-link></li> -->
                                            <li> <router-link to="#" class="thm-heading-paragraph"
                                                    @click.prevent="handleNav('/agent/train/refund-report-train')"> Refund / cancellation</router-link></li>
                                        </ul>
                                    </div>
                                </div>

                                <div class="menu-tab-list menu-tab-width">
                                    <div class="menu-tab-list-header">
                                        <button type="button" class="thm-heading-six" v-on:click="menusubtab">Travelers
                                        </button>
                                    </div>
                                    <div class="mega-menu-tab-sub-con">
                                        <ul>
                                            <li><router-link to="#" class="thm-heading-paragraph"  @click="$router.replace('/agent/train/manage-travellers')">Manage traveller</router-link></li>
                                        </ul>
                                    </div>
                                </div>

                                <div class="menu-tab-list menu-tab-width">
                                    <div class="menu-tab-list-header">
                                        <button type="button" class="thm-heading-six" v-on:click="menusubtab">Others
                                        </button>
                                    </div>
                                    <div class="mega-menu-tab-sub-con">
                                        <ul>
                                            <li><router-link to="#" class="thm-heading-paragraph">Download IRCTC
                                                    Certificate</router-link></li>
                                            <li><router-link to="#" class="thm-heading-paragraph">IRCTC Next renewal
                                                    date
                                                    06-09-2023</router-link></li>

                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="menu-tab-item money-transfer-sec menuhover-active" id="money-transfer">
                            <div class="menu-tab-item-row  justify-content-start row">

                                <div class="col-4 menu-tab-list">
                                    <div class="menu-tab-list-header">
                                        <button type="button" class="thm-heading-six" v-on:click="menusubtab">Search
                                        </button>
                                    </div>
                                    <div class="mega-menu-tab-sub-con">
                                        <ul>
                                            <li> <router-link to="#" class="thm-heading-paragraph"> Transfer money
                                                </router-link></li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="col-4 menu-tab-list">
                                    <div class="menu-tab-list-header">
                                        <button type="button" class="thm-heading-six" v-on:click="menusubtab">Report
                                        </button>
                                    </div>
                                    <div class="mega-menu-tab-sub-con">
                                        <ul>
                                            <li> <router-link to="#" class="thm-heading-paragraph"> Money transfer
                                                    report
                                                </router-link> </li>
                                            <li> <router-link to="#" class="thm-heading-paragraph">
                                                    Invoice</router-link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>


                            </div>
                        </div>

                        <div class="menu-tab-item menuhover-active" id="hotel-sec">
                            <div class="menu-tab-item-row">
                                <div class="menu-tab-list menu-tab-width">
                                    <div class="menu-tab-list-header">
                                        <button type="button" class="thm-heading-six" v-on:click="menusubtab">Schedule
                                        </button>
                                    </div>
                                    <div class="mega-menu-tab-sub-con">
                                        <ul>
                                            <li> <router-link to="#" class="thm-heading-paragraph">Trip
                                                    Calendar</router-link></li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="menu-tab-list menu-tab-width">
                                    <div class="menu-tab-list-header">
                                        <button type="button" class="thm-heading-six" v-on:click="menusubtab">Search
                                        </button>
                                    </div>
                                    <div class="mega-menu-tab-sub-con">
                                        <ul>
                                            <li> 
                                                <router-link to="#" class="thm-heading-paragraph"
                                                    @click.prevent="handleNav('/agent/hotel')"> Book Now</router-link>
                                            </li>
                                            <li> <router-link to="#" class="thm-heading-paragraph"> Hotel Offline
                                                    Booking</router-link></li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="menu-tab-list menu-tab-width">
                                    <div class="menu-tab-list-header">
                                        <button type="button" class="thm-heading-six" v-on:click="menusubtab">Report
                                        </button>
                                    </div>
                                    <div class="mega-menu-tab-sub-con">
                                        <ul>
                                            <li> <router-link to="#" class="thm-heading-paragraph"> Booking report
                                                </router-link> </li>
                                            <li> <router-link to="#" class="thm-heading-paragraph"> Refund
                                                    report</router-link></li>
                                        </ul>
                                    </div>
                                </div>

                                <div class="menu-tab-list menu-tab-width">
                                    <div class="menu-tab-list-header">
                                        <button type="button" class="thm-heading-six" v-on:click="menusubtab">Accounts
                                        </button>
                                    </div>
                                    <div class="mega-menu-tab-sub-con">
                                        <ul>
                                            <li><router-link to="#" class="thm-heading-paragraph"> Markup</router-link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                <div class="menu-tab-list menu-tab-width">
                                    <div class="menu-tab-list-header">
                                        <button type="button" class="thm-heading-six" v-on:click="menusubtab">Travellers
                                        </button>
                                    </div>
                                    <div class="mega-menu-tab-sub-con">
                                        <ul>
                                            <li><router-link to="#" class="thm-heading-paragraph"> Manage
                                                    traveller</router-link></li>

                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="menu-tab-item menuhover-active" id="bus-sec">
                            <div class="menu-tab-item-row">
                                <div class="menu-tab-list menu-tab-width">
                                    <div class="menu-tab-list-header">
                                        <button type="button" class="thm-heading-six" v-on:click="menusubtab">Schedule
                                        </button>
                                    </div>
                                    <div class="mega-menu-tab-sub-con">
                                        <ul>
                                            <li> <router-link to="#" class="thm-heading-paragraph">Trip
                                                    Calendar</router-link></li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="menu-tab-list menu-tab-width">
                                    <div class="menu-tab-list-header">
                                        <button type="button" class="thm-heading-six" v-on:click="menusubtab">Search
                                        </button>
                                    </div>
                                    <div class="mega-menu-tab-sub-con">
                                        <ul>
                                            <li> <router-link to="#" class="thm-heading-paragraph"> Book
                                                    Now</router-link>
                                            </li>
                                            <li> <router-link to="#" class="thm-heading-paragraph"> Bus Offline
                                                    Booking</router-link></li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="menu-tab-list menu-tab-width">
                                    <div class="menu-tab-list-header">
                                        <button type="button" class="thm-heading-six" v-on:click="menusubtab">Report
                                        </button>
                                    </div>
                                    <div class="mega-menu-tab-sub-con">
                                        <ul>
                                            <li> <router-link to="#" class="thm-heading-paragraph"> Booking report
                                                </router-link> </li>
                                            <li> <router-link to="#" class="thm-heading-paragraph"> View
                                                    Booking</router-link></li>
                                            <li> <router-link to="#" class="thm-heading-paragraph"> Cancel
                                                    Booking</router-link></li>
                                            <li> <router-link to="#" class="thm-heading-paragraph"> Customer
                                                    Invoice</router-link></li>
                                            <li> <router-link to="#" class="thm-heading-paragraph"> Refund
                                                    report</router-link></li>
                                        </ul>
                                    </div>
                                </div>

                                <div class="menu-tab-list menu-tab-width">
                                    <div class="menu-tab-list-header">
                                        <button type="button" class="thm-heading-six" v-on:click="menusubtab">Accounts
                                        </button>
                                    </div>
                                    <div class="mega-menu-tab-sub-con">
                                        <ul>
                                            <li><router-link to="#" class="thm-heading-paragraph">
                                                    Commission</router-link>
                                            </li>
                                            <li><router-link to="#" class="thm-heading-paragraph"> Markup</router-link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                <div class="menu-tab-list menu-tab-width">
                                    <div class="menu-tab-list-header">
                                        <button type="button" class="thm-heading-six" v-on:click="menusubtab">Travellers
                                        </button>
                                    </div>
                                    <div class="mega-menu-tab-sub-con">
                                        <ul>
                                            <li><router-link to="#" class="thm-heading-paragraph"> Manage
                                                    traveller</router-link></li>

                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="menu-tab-item money-transfer-sec menuhover-active" id="recharge-sec">
                            <div class="menu-tab-item-row  justify-content-start row">

                                <div class="col-4 menu-tab-list">
                                    <div class="menu-tab-list-header">
                                        <button type="button" class="thm-heading-six" v-on:click="menusubtab">Search
                                        </button>
                                    </div>
                                    <div class="mega-menu-tab-sub-con">
                                        <ul>
                                            <li> <router-link to="#" class="thm-heading-paragraph"> Prepaid recharge
                                                </router-link></li>
                                            <li> <router-link to="#" class="thm-heading-paragraph"> Postpaid Bill
                                                    payment
                                                </router-link></li>
                                            <li> <router-link to="#" class="thm-heading-paragraph"> DTH recharge
                                                </router-link></li>
                                            <li> <router-link to="#" class="thm-heading-paragraph"> Electricity
                                                </router-link></li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="col-4 menu-tab-list">
                                    <div class="menu-tab-list-header">
                                        <button type="button" class="thm-heading-six" v-on:click="menusubtab">Report
                                        </button>
                                    </div>
                                    <div class="mega-menu-tab-sub-con">
                                        <ul>
                                            <li> <router-link to="#" class="thm-heading-paragraph"> Recharge report
                                                </router-link> </li>
                                        </ul>
                                    </div>
                                </div>


                            </div>
                        </div>

                        <div class="menu-tab-item money-transfer-sec menuhover-active" id="holiday-sec">
                            <div class="menu-tab-item-row  justify-content-start row">

                                <div class="col-4 menu-tab-list">
                                    <div class="menu-tab-list-header">
                                        <button type="button" class="thm-heading-six" v-on:click="menusubtab">Search
                                        </button>
                                    </div>
                                    <div class="mega-menu-tab-sub-con">
                                        <ul>
                                            <li> <router-link to="#" class="thm-heading-paragraph"> Book
                                                    Now</router-link>
                                            </li>
                                            <li> <router-link to="#" class="thm-heading-paragraph"> Offline Package
                                                    Booking
                                                </router-link></li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="col-4 menu-tab-list">
                                    <div class="menu-tab-list-header">
                                        <button type="button" class="thm-heading-six" v-on:click="menusubtab">Report
                                        </button>
                                    </div>
                                    <div class="mega-menu-tab-sub-con">
                                        <ul>
                                            <li> <router-link to="#" class="thm-heading-paragraph"> Enquiry
                                                    Report</router-link> </li>
                                            <li> <router-link to="#" class="thm-heading-paragraph"> Booking
                                                    Report</router-link> </li>
                                            <li> <router-link to="#" class="thm-heading-paragraph"> Offline Booking
                                                    report</router-link> </li>
                                        </ul>
                                    </div>
                                </div>


                            </div>
                        </div>

                        <div class="menu-tab-item money-transfer-sec menuhover-active" id="tourism-sec">
                            <div class="menu-tab-item-row  justify-content-start row">

                                <div class="col-4 menu-tab-list">
                                    <div class="menu-tab-list-header">
                                        <button type="button" class="thm-heading-six" v-on:click="menusubtab">Search
                                        </button>
                                    </div>
                                    <div class="mega-menu-tab-sub-con">
                                        <ul>
                                            <li> <router-link to="#" class="thm-heading-paragraph"
                                                    @click.prevent="handleNav('/agent/tourismBooking')"> Book
                                                    Now</router-link>
                                            </li>
                                            <li> <router-link to="#" class="thm-heading-paragraph"
                                                    @click.prevent="handleNav('/agent/tourismList')"> All Packages
                                                </router-link></li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="col-4 menu-tab-list">
                                    <div class="menu-tab-list-header">
                                        <button type="button" class="thm-heading-six" v-on:click="menusubtab">Report
                                        </button>
                                    </div>
                                    <div class="mega-menu-tab-sub-con">
                                        <ul>
                                            <li> <router-link to="#" class="thm-heading-paragraph"> Booking Report
                                                </router-link> </li>
                                            <li> <router-link to="#" class="thm-heading-paragraph"> Cancel/Refund Report
                                                </router-link> </li>
                                        </ul>
                                    </div>
                                </div>


                            </div>
                        </div>

                        <div class="menu-tab-item money-transfer-sec menuhover-active" id="more-tab-sec">
                            <div class="menu-tab-item-row  justify-content-start row">
                                <div class="col-4 menu-tab-list">
                                    <div class="menu-tab-list-header">
                                        <button type="button" class="thm-heading-six" v-on:click="menusubtab">Visa
                                        </button>
                                    </div>
                                    <div class="mega-menu-tab-sub-con">
                                        <ul>
                                            <li> <router-link to="#" class="thm-heading-paragraph"> Request
                                                    Now</router-link></li>
                                            <li> <router-link to="#" class="thm-heading-paragraph"> Booking Report
                                                </router-link></li>
                                        </ul>
                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <div class="mega-menu-responsive ">
            <div class="container-fluid custom-container ">
                <div class="mega-menu-responsive-sec">
                    <p class="thm-heading-paragraph">Service</p>
                    <div class="mega-menu-responsive-con">
                        <span class="thm-heading-small ">View</span>
                        <div class="mega-responsive-btn">
                            <button type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasExample"
                                aria-controls="offcanvasExample"><img
                                    src="../../public/Agent/images/balance-credit-menu.svg" alt=""></button>
                        </div>

                    </div>
                </div>
            </div>
        </div>

    </section>

    <div class="offcanvas  offcanvas-end mega-menu-offcanvas " tabindex="-1" id="offcanvasExample"
        aria-labelledby="offcanvasExampleLabel">
        <div class="offcanvas-header">
            <h3 class="offcanvas-title thm-heading-three" id="offcanvasExampleLabel">All Service</h3>
            <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
        </div>
        <div class="offcanvas-body p-0">
            <div class="mega-sub-list">
                <ul>
                    <li>
                        <button type="button" class="mega-sub-list-item"
                            @click="setMenu('main_menu', 'Flight'); handleNav('/agent/flight')">
                            <img src="../../public/Agent/images/flight-tab-icon.svg" alt="">
                            <h6 class="thm-heading-six">Flight</h6>
                        </button>

                        <div class="mega-sub-list-item-two" :class="main_menu == 'Flight' ? 'show' : ''">
                            <div class="menu-tab-item-row  justify-content-start row">
                                <div class="col-4 menu-tab-list">
                                    <div class="menu-tab-list-header">
                                        <button type="button" class="thm-heading-six"
                                            @click="setMenu('sub_menu', 'flight1')">Schedule
                                        </button>
                                    </div>
                                    <div class="mega-menu-tab-sub-con" :class="sub_menu == 'flight1' ? 'show' : ''">
                                        <ul>
                                            <li> <router-link to="#" class="thm-heading-paragraph"> Trip
                                                    Calendar</router-link></li>
                                            <li> <router-link to="#" class="thm-heading-paragraph"> Flight Offline
                                                    Booking</router-link></li>
                                        </ul>
                                    </div>
                                </div>

                            </div>
                        </div>

                    </li>

                    <li>
                        <button @click="setMenu('main_menu', 'train')" type="button" class="mega-sub-list-item">
                            <img src="../../public/Agent/images/train-tab-icon.svg" alt="">
                            <h6 class="thm-heading-six">Train </h6>
                        </button>
                        <div class="mega-sub-list-item-two" :class="main_menu == 'train' ? 'show' : ''">
                            <div class="menu-tab-item-row">
                                <div class="menu-tab-list menu-tab-width">
                                    <div class="menu-tab-list-header">
                                        <button type="button" class="thm-heading-six"
                                            @click="setMenu('sub_menu', 'train1')">Schedule
                                        </button>
                                    </div>
                                    <div class="mega-menu-tab-sub-con" :class="sub_menu == 'train1' ? 'show' : ''">
                                        <ul>
                                            <li @click="setMenu('page_menu', 'trip_calendar')">
                                                <router-link to="#" class="thm-heading-paragraph">Trip
                                                    Calendar</router-link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="menu-tab-list menu-tab-width">
                                    <div class="menu-tab-list-header">
                                        <button type="button" class="thm-heading-six "
                                            @click="setMenu('sub_menu', 'train2')">Search
                                        </button>
                                    </div>
                                    <div class="mega-menu-tab-sub-con" :class="sub_menu == 'train2' ? 'show' : ''">
                                        <ul>
                                            <li> <router-link to="#" class="thm-heading-paragraph"
                                                    @click.prevent="handleNav('/agent/train')"> Book Now</router-link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="menu-tab-list menu-tab-width">
                                    <div class="menu-tab-list-header">
                                        <button type="button" class="thm-heading-six"
                                            @click="setMenu('sub_menu', 'train3')">Report
                                        </button>
                                    </div>
                                    <div class="mega-menu-tab-sub-con" :class="sub_menu == 'train3' ? 'show' : ''">
                                        <ul>
                                            <li> <router-link to="#" class="thm-heading-paragraph"
                                                    @click.prevent="handleNav('/agent/train/report')"> Booking report
                                                </router-link> </li>
                                            <li> <router-link to="#" class="thm-heading-paragraph"> View
                                                    ticket</router-link></li>
                                            <li> <router-link to="#" class="thm-heading-paragraph"> Cancel
                                                    ticket</router-link></li>
                                            <li> <router-link to="#" class="thm-heading-paragraph"> PNR
                                                    details</router-link></li>
                                            <li> <router-link to="#" class="thm-heading-paragraph"> TDR
                                                    request</router-link></li>
                                            <li> <router-link to="#" class="thm-heading-paragraph"> TDR request
                                                    history</router-link></li>
                                            <li> <router-link to="#" class="thm-heading-paragraph"> Change boarding
                                                    time</router-link></li>
                                            <li> <router-link to="#" class="thm-heading-paragraph"
                                                    @click.prevent="handleNav('/agent/refund-report-train')"> Refund/
                                                    cancellation</router-link></li>
                                        </ul>
                                    </div>
                                </div>

                                <div class="menu-tab-list menu-tab-width">
                                    <div class="menu-tab-list-header">
                                        <button type="button" class="thm-heading-six"
                                            @click="setMenu('sub_menu', 'train4')">Travelers
                                        </button>
                                    </div>
                                    <div class="mega-menu-tab-sub-con" :class="sub_menu == 'train4' ? 'show' : ''">
                                        <ul>
                                            <li><router-link to="#" class="thm-heading-paragraph">Manage
                                                    traveller</router-link></li>
                                        </ul>
                                    </div>
                                </div>

                                <div class="menu-tab-list menu-tab-width">
                                    <div class="menu-tab-list-header">
                                        <button type="button" class="thm-heading-six"
                                            @click="setMenu('sub_menu', 'train5')">Others
                                        </button>
                                    </div>
                                    <div class="mega-menu-tab-sub-con" :class="sub_menu == 'train5' ? 'show' : ''">
                                        <ul>
                                            <li><router-link to="#" class="thm-heading-paragraph">Download IRCTC
                                                    Certificate</router-link></li>
                                            <li><router-link to="#" class="thm-heading-paragraph">IRCTC Next renewal
                                                    date
                                                    06-09-2023</router-link></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>

                    <li>
                        <button @click="setMenu('main_menu', 'MoneyTransfer')" type="button" class="mega-sub-list-item">
                            <img src="../../public/Agent/images/money-tab-icon.svg" alt="">
                            <h6 class="thm-heading-six"> Money Transfer </h6>
                        </button>
                        <div class="mega-sub-list-item-two" :class="main_menu == 'MoneyTransfer' ? 'show' : ''">
                            <div class="menu-tab-item-row  justify-content-start row">
                                <div class="col-4 menu-tab-list">
                                    <div class="menu-tab-list-header">
                                        <button type="button" class="thm-heading-six"
                                            @click="setMenu('sub_menu', 'MoneyTransfer1')">Search
                                        </button>
                                    </div>
                                    <div class="mega-menu-tab-sub-con"
                                        :class="sub_menu == 'MoneyTransfer1' ? 'show' : ''">
                                        <ul>
                                            <li> <router-link to="#" class="thm-heading-paragraph"> Transfer money
                                                </router-link></li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="col-4 menu-tab-list">
                                    <div class="menu-tab-list-header">
                                        <button type="button" class="thm-heading-six"
                                            @click="setMenu('sub_menu', 'MoneyTransfer2')">Report
                                        </button>
                                    </div>
                                    <div class="mega-menu-tab-sub-con"
                                        :class="sub_menu == 'MoneyTransfer2' ? 'show' : ''">
                                        <ul>
                                            <li> <router-link to="#" class="thm-heading-paragraph"> Money transfer
                                                    report
                                                </router-link> </li>
                                            <li> <router-link to="#" class="thm-heading-paragraph">
                                                    Invoice</router-link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>


                            </div>
                        </div>
                    </li>

                    <li>
                        <button type="button" class="mega-sub-list-item" @click="setMenu('main_menu', 'hoteltab'); handleNav('/agent/hotel')">
                            <img src="../../public/Agent/images/hotel-tab-icon.svg" alt="">
                            <h6 class="thm-heading-six"> Hotel </h6>
                        </button>
                        <div class="mega-sub-list-item-two" :class="main_menu == 'hoteltab' ? 'show' : ''">
                            <div class="menu-tab-item-row">
                                <div class="menu-tab-list menu-tab-width">
                                    <div class="menu-tab-list-header">
                                        <button type="button" class="thm-heading-six"
                                            @click="setMenu('sub_menu', 'hoteltab1')">Schedule
                                        </button>
                                    </div>
                                    <div class="mega-menu-tab-sub-con" :class="sub_menu == 'hoteltab1' ? 'show' : ''">
                                        <ul>
                                            <li> <router-link to="#" class="thm-heading-paragraph">Trip
                                                    Calendar</router-link></li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="menu-tab-list menu-tab-width">
                                    <div class="menu-tab-list-header">
                                        <button type="button" class="thm-heading-six"
                                            @click="setMenu('sub_menu', 'hoteltab2')">Search
                                        </button>
                                    </div>
                                    <div class="mega-menu-tab-sub-con" :class="sub_menu == 'hoteltab2' ? 'show' : ''">
                                        <ul>
                                            <li> <router-link to="#" class="thm-heading-paragraph"> Book
                                                    Now</router-link>
                                            </li>
                                            <li> <router-link to="#" class="thm-heading-paragraph"> Hotel Offline
                                                    Booking</router-link></li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="menu-tab-list menu-tab-width">
                                    <div class="menu-tab-list-header">
                                        <button type="button" class="thm-heading-six"
                                            @click="setMenu('sub_menu', 'hoteltab3')">Report
                                        </button>
                                    </div>
                                    <div class="mega-menu-tab-sub-con" :class="sub_menu == 'hoteltab3' ? 'show' : ''">
                                        <ul>
                                            <li> <router-link to="#" class="thm-heading-paragraph"> Booking report
                                                </router-link> </li>
                                            <li> <router-link to="#" class="thm-heading-paragraph"> Refund
                                                    report</router-link></li>
                                        </ul>
                                    </div>
                                </div>

                                <div class="menu-tab-list menu-tab-width">
                                    <div class="menu-tab-list-header">
                                        <button type="button" class="thm-heading-six"
                                            @click="setMenu('sub_menu', 'hoteltab4')">Accounts
                                        </button>
                                    </div>
                                    <div class="mega-menu-tab-sub-con" :class="sub_menu == 'hoteltab4' ? 'show' : ''">
                                        <ul>
                                            <li><router-link to="#" class="thm-heading-paragraph"> Markup</router-link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                <div class="menu-tab-list menu-tab-width">
                                    <div class="menu-tab-list-header">
                                        <button type="button" class="thm-heading-six"
                                            @click="setMenu('sub_menu', 'hoteltab5')">Travellers
                                        </button>
                                    </div>
                                    <div class="mega-menu-tab-sub-con" :class="sub_menu == 'hoteltab5' ? 'show' : ''">
                                        <ul>
                                            <li><router-link to="#" class="thm-heading-paragraph"> Manage
                                                    traveller</router-link></li>

                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>

                    <li>
                        <button type="button" class="mega-sub-list-item" @click="setMenu('main_menu', 'Bus')">
                            <img src="../../public/Agent/images/bus-tab-icon.svg" alt="">
                            <h6 class="thm-heading-six"> Bus </h6>
                        </button>
                        <div class="mega-sub-list-item-two" :class="main_menu == 'Bus' ? 'show' : ''">
                            <div class="menu-tab-item-row">
                                <div class="menu-tab-list menu-tab-width">
                                    <div class="menu-tab-list-header">
                                        <button type="button" class="thm-heading-six"
                                            @click="setMenu('sub_menu', 'Bus1')">Schedule
                                        </button>
                                    </div>
                                    <div class="mega-menu-tab-sub-con" :class="sub_menu == 'Bus1' ? 'show' : ''">
                                        <ul>
                                            <li> <router-link to="#" class="thm-heading-paragraph">Trip
                                                    Calendar</router-link></li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="menu-tab-list menu-tab-width">
                                    <div class="menu-tab-list-header">
                                        <button type="button" class="thm-heading-six"
                                            @click="setMenu('sub_menu', 'Bus2')">Search
                                        </button>
                                    </div>
                                    <div class="mega-menu-tab-sub-con" :class="sub_menu == 'Bus2' ? 'show' : ''">
                                        <ul>
                                            <li> <router-link to="#" class="thm-heading-paragraph"> Book
                                                    Now</router-link>
                                            </li>
                                            <li> <router-link to="#" class="thm-heading-paragraph"> Bus Offline
                                                    Booking</router-link></li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="menu-tab-list menu-tab-width">
                                    <div class="menu-tab-list-header">
                                        <button type="button" class="thm-heading-six"
                                            @click="setMenu('sub_menu', 'Bus3')">Report
                                        </button>
                                    </div>
                                    <div class="mega-menu-tab-sub-con" :class="sub_menu == 'Bus3' ? 'show' : ''">
                                        <ul>
                                            <li> <router-link to="#" class="thm-heading-paragraph"> Booking report
                                                </router-link> </li>
                                            <li> <router-link to="#" class="thm-heading-paragraph"> View
                                                    Booking</router-link></li>
                                            <li> <router-link to="#" class="thm-heading-paragraph"> Cancel
                                                    Booking</router-link></li>
                                            <li> <router-link to="#" class="thm-heading-paragraph"> Customer
                                                    Invoice</router-link></li>
                                            <li> <router-link to="#" class="thm-heading-paragraph"> Refund
                                                    report</router-link></li>
                                        </ul>
                                    </div>
                                </div>

                                <div class="menu-tab-list menu-tab-width">
                                    <div class="menu-tab-list-header">
                                        <button type="button" class="thm-heading-six"
                                            @click="setMenu('sub_menu', 'Bus4')">Accounts
                                        </button>
                                    </div>
                                    <div class="mega-menu-tab-sub-con" :class="sub_menu == 'Bus4' ? 'show' : ''">
                                        <ul>
                                            <li><router-link to="#" class="thm-heading-paragraph">
                                                    Commission</router-link>
                                            </li>
                                            <li><router-link to="#" class="thm-heading-paragraph"> Markup</router-link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                <div class="menu-tab-list menu-tab-width">
                                    <div class="menu-tab-list-header">
                                        <button type="button" class="thm-heading-six"
                                            @click="setMenu('sub_menu', 'Bus5')">Travellers
                                        </button>
                                    </div>
                                    <div class="mega-menu-tab-sub-con" :class="sub_menu == 'Bus5' ? 'show' : ''">
                                        <ul>
                                            <li><router-link to="#" class="thm-heading-paragraph"> Manage
                                                    traveller</router-link></li>

                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>

                    <li>
                        <button type="button" class="mega-sub-list-item" @click="setMenu('main_menu', 'Recharge')">
                            <img src="../../public/Agent/images/recharge-tab-icon.svg" alt="">
                            <h6 class="thm-heading-six"> Recharge </h6>
                        </button>
                        <div class="mega-sub-list-item-two" :class="main_menu == 'Recharge' ? 'show' : ''">
                            <div class="menu-tab-item-row  justify-content-start row">

                                <div class="col-4 menu-tab-list">
                                    <div class="menu-tab-list-header">
                                        <button type="button" class="thm-heading-six"
                                            @click="setMenu('sub_menu', 'Recharge1')">Search
                                        </button>
                                    </div>
                                    <div class="mega-menu-tab-sub-con" :class="sub_menu == 'Recharge1' ? 'show' : ''">
                                        <ul>
                                            <li> <router-link to="#" class="thm-heading-paragraph"> Prepaid recharge
                                                </router-link></li>
                                            <li> <router-link to="#" class="thm-heading-paragraph"> Postpaid Bill
                                                    payment
                                                </router-link></li>
                                            <li> <router-link to="#" class="thm-heading-paragraph"> DTH recharge
                                                </router-link></li>
                                            <li> <router-link to="#" class="thm-heading-paragraph"> Electricity
                                                </router-link></li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="col-4 menu-tab-list">
                                    <div class="menu-tab-list-header">
                                        <button type="button" class="thm-heading-six"
                                            @click="setMenu('sub_menu', 'Recharge2')">Report
                                        </button>
                                    </div>
                                    <div class="mega-menu-tab-sub-con" :class="sub_menu == 'Recharge2' ? 'show' : ''">
                                        <ul>
                                            <li> <router-link to="#" class="thm-heading-paragraph"> Recharge report
                                                </router-link> </li>
                                        </ul>
                                    </div>
                                </div>


                            </div>
                        </div>
                    </li>


                    <li>
                        <button type="button" class="mega-sub-list-item" @click="setMenu('main_menu', 'Holiday')">
                            <img src="../../public/Agent/images/mega-menu-tab-holiday.svg" alt="">
                            <h6 class="thm-heading-six"> Holiday </h6>
                        </button>
                        <div class="mega-sub-list-item-two" :class="main_menu == 'Holiday' ? 'show' : ''">
                            <div class="menu-tab-item-row  justify-content-start row">

                                <div class="col-4 menu-tab-list">
                                    <div class="menu-tab-list-header">
                                        <button type="button" class="thm-heading-six"
                                            @click="setMenu('sub_menu', 'Holiday1')">Search
                                        </button>
                                    </div>
                                    <div class="mega-menu-tab-sub-con" :class="sub_menu == 'Holiday1' ? 'show' : ''">
                                        <ul>
                                            <li> <router-link to="#" class="thm-heading-paragraph"> Book
                                                    Now</router-link>
                                            </li>
                                            <li> <router-link to="#" class="thm-heading-paragraph"> Offline Package
                                                    Booking
                                                </router-link></li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="col-4 menu-tab-list">
                                    <div class="menu-tab-list-header">
                                        <button type="button" class="thm-heading-six"
                                            @click="setMenu('sub_menu', 'Holiday2')">Report
                                        </button>
                                    </div>
                                    <div class="mega-menu-tab-sub-con" :class="sub_menu == 'Holiday2' ? 'show' : ''">
                                        <ul>
                                            <li> <router-link to="#" class="thm-heading-paragraph"> Enquiry
                                                    Report</router-link> </li>
                                            <li> <router-link to="#" class="thm-heading-paragraph"> Booking
                                                    Report</router-link> </li>
                                            <li> <router-link to="#" class="thm-heading-paragraph"> Offline Booking
                                                    report</router-link> </li>
                                        </ul>
                                    </div>
                                </div>


                            </div>
                        </div>
                    </li>


                    <li>
                        <button type="button" class="mega-sub-list-item"
                            @click="setMenu('main_menu', 'tourismtab'); handleNav('/agent/tourismBooking')">
                            <img src="../../public/Agent/images/tourism-tab-icon.svg" alt="">
                            <h6 class="thm-heading-six"> Irctc Tourism </h6>
                        </button>
                        <div class="mega-sub-list-item-two" :class="main_menu == 'tourismtab' ? 'show' : ''">
                            <div class="menu-tab-item-row  justify-content-start row">

                                <div class="col-4 menu-tab-list">
                                    <div class="menu-tab-list-header">
                                        <button type="button" class="thm-heading-six"
                                            @click="setMenu('sub_menu', 'tourismtab1')">Search
                                        </button>
                                    </div>
                                    <div class="mega-menu-tab-sub-con" :class="sub_menu == 'tourismtab1' ? 'show' : ''">
                                        <ul>
                                            <li> <router-link to="#" class="thm-heading-paragraph"
                                                    @click.prevent="handleNav('/agent/tourismBooking')"> Book
                                                    Now</router-link>
                                            </li>
                                            <li> <router-link to="#" class="thm-heading-paragraph"
                                                    @click.prevent="handleNav('/agent/tourismList')"> All Packages
                                                </router-link></li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="col-4 menu-tab-list">
                                    <div class="menu-tab-list-header">
                                        <button type="button" class="thm-heading-six"
                                            @click="setMenu('sub_menu', 'tourismtab2')">Report
                                        </button>
                                    </div>
                                    <div class="mega-menu-tab-sub-con" :class="sub_menu == 'tourismtab2' ? 'show' : ''">
                                        <ul>
                                            <li> <router-link to="#" class="thm-heading-paragraph"> Booking Report
                                                </router-link> </li>
                                            <li> <router-link to="#" class="thm-heading-paragraph"> Cancel/Refund Report
                                                </router-link> </li>
                                        </ul>
                                    </div>
                                </div>


                            </div>
                        </div>
                    </li>


                    <li>
                        <button type="button" class="mega-sub-list-item" @click="setMenu('main_menu', 'Moretab')">
                            <img src="../../public/Agent/images/more-tab-icon.svg" alt="">
                            <h6 class="thm-heading-six"> More </h6>
                        </button>
                        <div class="mega-sub-list-item-two" :class="main_menu == 'Moretab' ? 'show' : ''">
                            <div class="menu-tab-item-row  justify-content-start row">
                                <div class="col-4 menu-tab-list">
                                    <div class="menu-tab-list-header">
                                        <button type="button" class="thm-heading-six"
                                            @click="setMenu('sub_menu', 'Moretab1')">Visa </button>
                                    </div>
                                    <div class="mega-menu-tab-sub-con" :class="sub_menu == 'Moretab1' ? 'show' : ''">
                                        <ul>
                                            <li> <router-link to="#" class="thm-heading-paragraph"> Request
                                                    Now</router-link></li>
                                            <li> <router-link to="#" class="thm-heading-paragraph"> Booking Report
                                                </router-link></li>
                                        </ul>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </li>

                </ul>
            </div>
        </div>
    </div>
</template>
<script>
import { agentStore } from '../store';
import ProfileService from '../profile/services/ProfileService';
export default {
    name: "AgentMenuTab",
    computed: {
        authData() {
            return agentStore();
        },
        UserPrivileges() {
            const privileges = this.authData.$state.UserData?.privileges;
            if (typeof privileges === 'string') {
                return privileges
                    .split(',')
                    .map(p => String(p).trim())
                    .filter(Boolean);
            }

            if (Array.isArray(privileges)) {
                return privileges.map(p => String(p).trim()).filter(Boolean);
            }

            return [];
        }
    },
    data() {

        return {
            showScroll2: false,
            active_menu: 0,
            showTooltip: false,
            main_menu: '',
            sub_menu: '',
            page_menu: '',
        }
    },
    watch: {
        $route() {
            this.showTooltip = false;
        }
    },

    methods: {
        closeMegaMenu() {
            this.showTooltip = false;

        },
        handleNav(path) {
            this.closeMegaMenu();
            this.$router.push(path); 
        },
        setMenu(key, slug) {
            this[key] = (this[key] == slug) ? '' : slug
        },
        changeTab(index) {
            this.activeTab = index;

        },
        scrollToServiceSection(val) {

            const menuTabItems = document.querySelectorAll('.menuhover-active');
            menuTabItems.forEach(item => {
                item.classList.remove('active');
            });

            event.target.classList.add('active')
            const serviceSection = document.getElementById(val);
            if (serviceSection) {
                serviceSection.classList.add('active');
            }


        },
        menusubtab() {

            const menusubtabItems = document.querySelectorAll('.menu-tab-list-header');
            menusubtabItems.forEach(item => {
                item.classList.remove('active');
            });

            const parentElement = event.target.closest('.menu-tab-list-header');
            parentElement.classList.add('active');

        },
        megasublist(event) {
            window.jQuery(".mega-sub-list-item-two").removeClass('show')
            const nextElement = event.target.nextElementSibling;
            if (nextElement.classList.contains('show')) {
                nextElement.classList.remove('show');
            } else {
                nextElement.classList.add('show');
            }
        },
        async fetchAgentBalance() {
            try {
                let agentBalanceResponse = await ProfileService.getAgentBalance();
                if (agentBalanceResponse && agentBalanceResponse.status === 1) {
                    if (Array.isArray(agentBalanceResponse.agentbalance) && agentBalanceResponse.agentbalance.length > 0) {
                        this.authData.$state.agentBalance = agentBalanceResponse.agentbalance[0];
                    }
                }
            } catch (error) {
                console.log(error);
            }
        }

    },
    mounted() {
        this.fetchAgentBalance();
    }
}

</script>